<template>
    <card-form
            class="card-form_max-xs"
            :validator="$validator"
            :form-errors.sync="errors"
            :model.sync="model"
            label-create="msg.createGroup"
            label-edit="msg.editGroup"
            route-edit="edit_group"
            action-load="loadGroup"
            action-create="createGroup"
            action-edit="editGroup"
            success-route="groups"
            :is-new.sync="isNew"
    >
        <v-card class="mt-4">
            <v-card-text
                    :class="{'c-pa-10': $vuetify.breakpoint.xsOnly}"
            >
                <v-text-field
                        :label="$t('msg.name')"
                        v-model="model.name"
                        :error-messages="errors.collect('name')"
                        data-vv-name="name"
                        v-validate="'max:255'"
                        outlined
                        :dense="!isMobile"
                        hide-details
                ></v-text-field>
                <v-select
                        v-model="model.type"
                        :label="$t('msg.type')"
                        :error-messages="errors.collect('type')"
                        data-vv-name="type"
                        :items="types"
                        :disabled="!isNew"
                        v-validate="'required'"
                        outlined
                        :dense="!isMobile"
                        hide-details
                        class="mt-3"
                >
                    <template v-slot:selection="{item}">
                        {{ $t('typeTransaction.'+item) }}
                    </template>
                    <template v-slot:item="{item}">
                        {{ $t('typeTransaction.'+item) }}
                    </template>
                </v-select>
                <c-switch
                        v-if="model.id !== null"
                        v-model="model.is_archive"
                        dense
                        hide-details="auto"
                        :label="$t('msg.isArchive')"
                        class="card-form__input"
                ></c-switch>
            </v-card-text>
        </v-card>
    </card-form>
</template>

<script>
    export default {
        data() {
            return {
                id: null,
                isNew: undefined,
                formLoading: false,
                modelLoading: false,
                model: {
                    id: null,
                    name: null,
                    type: null,
                    is_archive: false
                },
                types: []
            }
        },
        watch: {
            model() {
                this.loadedModel();
            }
        },
        methods: {
            loadedModel() {
                this.$store.commit('setBreadcrumbs', [{id: 2, name: this.model.name}]);
            },
            loadTypes() {
                this.$store.dispatch('loadGroupTypes')
                    .then(res => this.types = res);
            }
        },
        created() {
            this.id = parseInt(this.$route.params.id);
            this.loadTypes();
        }
    }
</script>